import Reveal from "@/components/base/Reveal";
import { testimonial } from "@/mocks/site";

export default function WhySection() {
  return (
    <>
      <section className="bg-background-100 px-4 md:px-10 py-16 md:py-24">
        <Reveal className="mx-auto max-w-3xl text-center">
          <h2 className="font-heading text-2xl md:text-4xl tracking-tight text-foreground-950">
            WHY DEFINITION FILMS
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-foreground-700">
            We take on a limited number of projects each year. Not because we're exclusive,
            but because we're genuinely invested in every client we work with.
          </p>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-700">
            That means you get direct access to the people actually making your film. No
            account managers, no handoffs, no surprises.
          </p>
        </Reveal>
      </section>

      <section className="bg-background-50 px-4 md:px-10 py-16 md:py-24">
        <Reveal className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl tracking-tight text-foreground-950">
            WHY OUR CLIENTS COME BACK
          </h2>
        </Reveal>

        <Reveal delay={120} className="mx-auto mt-12 max-w-2xl">
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:items-start sm:gap-8">
            <img
              src={testimonial.avatar}
              alt={testimonial.avatarAlt}
              title="Ryan Johnson, Ridge Vineyards"
              className="h-16 w-16 shrink-0 rounded-full object-cover"
            />
            <div>
              <p className="text-sm text-foreground-700">
                <strong className="font-semibold text-foreground-950">
                  {testimonial.name}
                </strong>
                , {testimonial.role}
              </p>
              <blockquote className="mt-4 font-heading text-xl leading-snug text-foreground-950 md:text-2xl">
                “{testimonial.quote}”
              </blockquote>
              <a
                href={testimonial.linkHref}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-block text-sm text-foreground-600 underline decoration-accent-400 decoration-1 underline-offset-4 transition-colors hover:text-accent-700"
              >
                Read the full verified review on Clutch
              </a>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}